import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { File } from '@ionic-native/file/ngx';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics/ngx';

import { HttpClientModule } from '@angular/common/http';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { ECGComponentsModule } from '../ecgcomponents/ecgcomponents.module'
import { SettingsPageModule } from './settings/settings.module'
import { SearchPageModule } from './search/search.module'

import { LeftSideBarComponent } from './left-side-bar/left-side-bar.component'

@NgModule({
  declarations: [
     AppComponent,
     LeftSideBarComponent,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot({mode: 'md',scrollAssist: false, }),
    AppRoutingModule,
    HttpClientModule,
    ECGComponentsModule,
    SettingsPageModule,
    SearchPageModule,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    File,
    FirebaseAnalytics,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
